/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_1_TextInputs */

const en_visa_eb2niw_point_1_text = /** @type {(inputs: Visa_Eb2niw_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The focus is on the substance and impact of the proposed endeavor, not on whether a client fits a single label or industry stereotype.`)
};

const pt_visa_eb2niw_point_1_text = /** @type {(inputs: Visa_Eb2niw_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O foco está na substância e no impacto do empreendimento proposto, não em se o cliente se encaixa em um único rótulo ou estereótipo do setor.`)
};

const es_visa_eb2niw_point_1_text = /** @type {(inputs: Visa_Eb2niw_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El enfoque está en la sustancia y el impacto del emprendimiento propuesto, no en si el cliente encaja en una sola etiqueta o estereotipo de la industria.`)
};

/**
* | output |
* | --- |
* | "The focus is on the substance and impact of the proposed endeavor, not on whether a client fits a single label or industry stereotype." |
*
* @param {Visa_Eb2niw_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_1_text = /** @type {((inputs?: Visa_Eb2niw_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_1_text(inputs)
	if (locale === "es") return es_visa_eb2niw_point_1_text(inputs)
	return en_visa_eb2niw_point_1_text(inputs)
});